/* ==========================================================================
   Stacks — social proof (snippets/social-proof.liquid hands in the data)
   Real numbers only: recent orders as a quiet toast, sold / visited pills on product pages,
   and the store's visits this week once per visit. Anything under its minimum stays hidden.
   ========================================================================== */
(() => {
  const el = document.querySelector('[data-proof]');
  if (!el) return;
  let data;
  try { data = JSON.parse(el.textContent); } catch { return; }
  const ar = data.ar;
  const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const store = (() => { try { return window.sessionStorage; } catch { return null; } })();
  const get = (k) => { try { return store?.getItem(`sp:${k}`); } catch { return null; } };
  const set = (k, v) => { try { store?.setItem(`sp:${k}`, v); } catch { /* private mode */ } };
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const num = (n) => (ar ? Number(n).toLocaleString('ar-EG') : Number(n).toLocaleString('en-US'));
  const ago = (iso) => {
    const m = Math.max(1, Math.round((Date.now() - Date.parse(iso)) / 60000));
    if (m < 60) return ar ? `من ${num(m)} دقيقة` : `${m} min ago`;
    const h = Math.round(m / 60);
    if (h < 24) return ar ? (h === 1 ? 'من ساعة' : h === 2 ? 'من ساعتين' : `من ${num(h)} ساعات`) : `${h} h ago`;
    const d = Math.round(h / 24);
    return ar ? (d === 1 ? 'امبارح' : d === 2 ? 'من يومين' : `من ${num(d)} أيام`) : d === 1 ? 'yesterday' : `${d} days ago`;
  };
  const ICON = {
    fire: '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true"><path fill="currentColor" d="M12 2c1 3.5-1.6 5-1.6 8 0 1.3.9 2.3 2 2.3 1.4 0 2.2-1.2 2-2.9C16.9 11 18 13 18 15.2 18 19 15.3 22 12 22s-6-2.8-6-6.6C6 10.3 10.2 7.6 12 2z"/></svg>',
    eye: '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></svg>',
    check: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7"/></svg>',
    close: '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
  };

  /* ---- product page pills ---- */
  const p = data.product;
  if (p) {
    const pills = [];
    if (p.sold30 >= data.min.sold) pills.push(`<span class="sp-pill sp-pill--hot">${ICON.fire}${ar ? `اتباع ${num(p.sold30)} مرة الشهر ده` : `${p.sold30} sold this month`}</span>`);
    if (p.visits7 >= data.min.visits) pills.push(`<span class="sp-pill">${ICON.eye}${ar ? `${num(p.visits7)} زيارة الأسبوع ده` : `${p.visits7} visits this week`}</span>`);
    if (pills.length) {
      const slot = document.querySelector('[data-proof-slot], [data-sale-row], .fam-buy__top, .nh-summary, [data-nh-controls]');
      if (slot) {
        const row = document.createElement('div');
        row.className = 'sp-pills';
        row.innerHTML = pills.join('');
        if (slot.matches('[data-proof-slot]')) slot.appendChild(row);
        else if (slot.matches('[data-nh-controls]')) slot.prepend(row);
        else slot.insertAdjacentElement('afterend', row);
      }
    }
  }

  /* ---- the toast: recent orders, then (once per visit) the store's week ---- */
  const recent = (data.recent || []).filter((r) => Date.now() - Date.parse(r.at) < 14 * 86400000);
  const queue = recent.map((r) => ({ kind: 'order', r }));
  if (!recent.length && data.week >= data.min.week && !get('week')) queue.push({ kind: 'week' });
  if (!queue.length || get('off') === '1') return;

  const box = document.createElement('div');
  box.className = 'sp-toast';
  box.setAttribute('role', 'status');
  box.setAttribute('aria-live', 'polite');
  box.dir = ar ? 'rtl' : 'ltr';
  document.body.appendChild(box);
  let shown = Number(get('n') || 0), i = Number(get('i') || 0) % queue.length, timer = null;
  const MAX = 4, FIRST = 9000, GAP = 28000, STAY = 6500;

  function html(item) {
    if (item.kind === 'week') {
      return `<div class="sp-toast__pulse" aria-hidden="true"></div>
        <div class="sp-toast__body"><b>${ar ? `${num(data.week)} شخص زاروا ستاكس الأسبوع ده` : `${num(data.week)} people visited Stacks this week`}</b>
        <small>${ar ? 'كل قطعة بتتطبع مخصوص في القاهرة' : 'Every piece is printed to order in Cairo'}</small></div>`;
    }
    const r = item.r;
    const who = r.name ? esc(r.name) : ar ? (r.city ? `عميل من ${esc(r.city)}` : 'عميل') : (r.city ? `Someone in ${esc(r.city)}` : 'Someone');
    return `<a class="sp-toast__link" href="${esc(r.url)}">
        ${r.image ? `<img class="sp-toast__img" src="${esc(r.image)}" alt="" width="56" height="56" loading="lazy">` : ''}
        <span class="sp-toast__body"><span class="sp-toast__who">${who} ${ar ? 'اشترى' : 'bought'}</span>
        <b>${esc(r.title)}</b>
        <small>${ago(r.at)} · <span class="sp-toast__ok">${ICON.check}${ar ? 'طلب حقيقي' : 'Verified order'}</span></small></span></a>`;
  }
  function show() {
    if (shown >= MAX || document.hidden) { schedule(GAP); return; }
    /* never over the WhatsApp chat or its speech bubble: wait for them to go */
    if (waBusy()) { schedule(6000); return; }
    const item = queue[i % queue.length];
    box.innerHTML = `${html(item)}<button type="button" class="sp-toast__x" aria-label="${ar ? 'إغلاق' : 'Close'}">${ICON.close}</button><i class="sp-toast__bar" style="animation-duration:${STAY}ms"></i>`;
    box.querySelector('.sp-toast__x').addEventListener('click', () => { hide(); set('off', '1'); clearTimeout(timer); });
    requestAnimationFrame(() => box.classList.add('is-on'));
    clearInterval(watch); watch = setInterval(() => { if (waBusy()) hide(true); }, 150);
    shown++; i++; set('n', String(shown)); set('i', String(i));
    if (item.kind === 'week') { set('week', '1'); queue.splice(queue.indexOf(item), 1); }
    setTimeout(hide, reduced ? STAY + 2000 : STAY);
    if (queue.length) schedule(GAP);
  }
  /* instant when the WhatsApp chat or its bubble takes the corner, a fade otherwise */
  function hide(now = false) { if (now) box.classList.add('is-gone'); box.classList.remove('is-on'); clearInterval(watch); if (now) setTimeout(() => box.classList.remove('is-gone'), 50); }
  const wa = document.querySelector('.wa');
  if (wa) new MutationObserver(() => { if (box.classList.contains('is-on') && waBusy()) hide(true); }).observe(wa, { subtree: true, attributes: true, attributeFilter: ['class', 'hidden', 'style'] });
  /* the WhatsApp chat and its speech bubble come first: the toast steps aside if either appears */
  function waBusy() {
    return [...document.querySelectorAll('.wa.is-open, .wa__nudge')].some((n) => {
      const cs = getComputedStyle(n), r = n.getBoundingClientRect();
      return cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.1 && r.height > 0;
    });
  }
  let watch = 0;
  function schedule(ms) { clearTimeout(timer); timer = setTimeout(show, ms); }
  box.addEventListener('mouseenter', () => box.classList.add('is-hold'));
  box.addEventListener('mouseleave', () => box.classList.remove('is-hold'));
  schedule(FIRST);
})();
